import React, { useEffect, useState } from "react";
import API_BASE from "../config/api";
import { useLocation } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { createPortal } from "react-dom";

export default function Wallet({ balance, onBalanceUpdate }) {




    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.personaluid;

    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAddFund, setShowAddFund] = useState(false);
    const [addAmount, setAddAmount] = useState("");
    const [payLoading, setPayLoading] = useState(false);

    const [searchParams] = useSearchParams();
    const paymentStatus = searchParams.get("payment");
    const [note, setNote] = useState("");


    useEffect(() => {
        if (!userId) return;

        fetch(`${API_BASE}/api/get_wallet.php?user_id=${userId}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    // ✅ update parent (Admin navbar)
                    onBalanceUpdate(data.balance || 0);

                    // ✅ wallet page data
                    setHistory(data.history || []);
                }
                setLoading(false);
            })
            .catch(() => setLoading(false));

    }, [userId, onBalanceUpdate]);
    const handleAddFund = async () => {
        if (!addAmount || addAmount <= 0) return;

        setPayLoading(true);

        try {
            const res = await fetch(`${API_BASE}/api/wallet_generate_fonepay.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    user_id: userId,
                    amount: addAmount,
                    note: note || null
                })

            });

            const data = await res.json();

            if (data.success && data.payment_url) {
                window.location.href = data.payment_url;
            } else {
                alert(data.message || "Unable to initiate payment");
            }
        } catch {
            alert("Network error");
        }

        setPayLoading(false);
    };



    const [toast, setToast] = useState({
        show: false,
        message: "",
        type: "success", // success | danger | info
        duration: 3000
    });

    useEffect(() => {
        if (!toast.show) return;

        const timer = setTimeout(() => {
            setToast(prev => ({ ...prev, show: false }));

            // ✅ CLEAN URL AFTER TOAST FINISHES (LIKE UPGRADELISTING)
            const url = new URL(window.location.href);
            url.searchParams.delete("payment");
            url.searchParams.delete("page");
            window.history.replaceState({}, "", url);

        }, toast.duration);

        return () => clearTimeout(timer);
    }, [toast.show]);



    useEffect(() => {
        if (!paymentStatus) return;

        if (paymentStatus === "success") {
            setToast({
                show: true,
                message: "Wallet topped up successfully 💰",
                type: "success",
                duration: 3500
            });
        }

        if (paymentStatus === "failed") {
            setToast({
                show: true,
                message: "Wallet top-up failed ❌",
                type: "danger",
                duration: 3500
            });
        }



    }, [paymentStatus]);


    return (
        <div className="container-fluid py-3" style={{ maxWidth: "1100px" }}>
            {/* TOAST */}
            {toast.show && (
                <div className={`custom-toast ${toast.type}`}>
                    <div className="toast-icon">
                        {toast.type === "success" && "✔"}
                        {toast.type === "danger" && "✖"}
                        {toast.type === "info" && "ℹ"}
                    </div>

                    <div className="toast-content">
                        <div className="toast-title">
                            {toast.type === "success" ? "Success" :
                                toast.type === "danger" ? "Error" : "Info"}
                        </div>
                        <div className="toast-message">{toast.message}</div>
                    </div>

                    <button
                        className="toast-close"
                        onClick={() => setToast({ ...toast, show: false })}
                    >
                        ×
                    </button>

                    <div
                        className="toast-progress"
                        style={{ animationDuration: `${toast.duration}ms` }}
                    />
                </div>
            )}


            {/* ================= WALLET SUMMARY ================= */}
            <div className="card shadow-sm mb-3">
                {/* HEADER */}
                <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                    <span>My Wallet</span>

                    <button
                        className="btn btn-success btn-sm px-3"
                        onClick={() => setShowAddFund(true)}
                    >
                        <i className="bi bi-plus-circle me-1"></i>
                        Add Funds
                    </button>
                </div>


                <div className="card-body">
                    <div className="row align-items-center">

                        {/* LEFT */}
                        <div className="col-md-6">
                            <small className="text-muted">Available Balance</small>
                            <h2 className="fw-bold text-success mb-0">
                                ₹ {balance.toLocaleString()}
                            </h2>
                            <small className="text-muted">
                                Can be used for promotions & upgrades
                            </small>
                        </div>



                    </div>
                </div>
            </div>

            {/* ================= WALLET STATUS ================= */}

            {/* ================= WALLET HISTORY ================= */}
            <div className="card shadow-sm">
                <div className="card-header bg-light fw-semibold">
                    Wallet / Reward History
                </div>

                <div className="card-body p-0">
                    {loading ? (
                        <div className="text-center py-4 text-muted">
                            Loading wallet history...
                        </div>
                    ) : history.length === 0 ? (
                        <div className="text-center py-4 text-muted">
                            No wallet transactions found
                        </div>
                    ) : (
                        <table className="table table-hover table-sm mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>Date</th>
                                    <th>Description</th>
                                    <th >Amount</th>
                                    <th>Status</th>
                                </tr>
                            </thead>

                            <tbody>
                                {history.map((row, i) => (
                                    <tr key={i}>
                                        <td className="text-muted small">
                                            {row.date}
                                        </td>

                                        <td>
                                            <div className="fw-semibold">
                                                {row.title}
                                            </div>
                                            {row.reference && (
                                                <small className="text-muted">
                                                    Ref: {row.reference}
                                                </small>
                                            )}
                                        </td>

                                        <td className={` fw-semibold ${row.type === "credit"
                                            ? "text-success"
                                            : "text-danger"
                                            }`}>
                                            {row.type === "credit" ? "+" : "-"} ₹ {row.amount}
                                        </td>

                                        <td>
                                            <span className={`badge ${row.status === "SUCCESS"
                                                ? "bg-success"
                                                : row.status === "PENDING"
                                                    ? "bg-warning text-dark"
                                                    : "bg-danger"
                                                }`}>
                                                {row.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
            {/* ================= ADD FUND MODAL ================= */}
            {showAddFund && (
                <>
                    <div className="modal show fade" style={{ display: "block" }} tabIndex="-1">
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content border-0 shadow-lg rounded-4">

                                {/* HEADER */}
                                <div className="modal-header bg-success text-white rounded-top-4">
                                    <h5 className="modal-title d-flex align-items-center gap-2">
                                        <i className="bi bi-wallet2 fs-4"></i>
                                        Add Funds to Wallet
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close btn-close-white"
                                        onClick={() => setShowAddFund(false)}
                                    />
                                </div>

                                {/* BODY */}
                                <div className="modal-body px-4 py-4">
                                    <div className="row g-3">

                                        {/* Amount */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">
                                                Amount (NPR)
                                            </label>

                                            <input
                                                type="text"
                                                className={`form-control form-control-lg ${addAmount !== "" && Number(addAmount) < 10 ? "is-invalid" : ""
                                                    }`}
                                                placeholder="Enter amount"
                                                value={addAmount}
                                                onChange={(e) => {
                                                    // allow only numbers
                                                    const value = e.target.value.replace(/\D/g, "");
                                                    setAddAmount(value);
                                                }}
                                            />

                                            {addAmount !== "" && Number(addAmount) < 10 ? (
                                                <div className="invalid-feedback d-block">
                                                    Minimum top-up amount is NPR 10
                                                </div>
                                            ) : (
                                                <small className="text-muted">
                                                    Minimum top-up amount is NPR 10
                                                </small>
                                            )}
                                        </div>


                                        {/* Optional Note */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">
                                                Note / Reference <span className="text-muted">(optional)</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                placeholder="Eg: Promotion budget, Ads, etc."
                                                value={note}
                                                onChange={(e) => setNote(e.target.value)}
                                            />
                                            <small className="text-muted">
                                                This is only for your reference
                                            </small>
                                        </div>

                                    </div>

                                    {/* INFO BANNER */}
                                    <div className="alert alert-light border mt-4 mb-0 d-flex gap-2">
                                        <i className="bi bi-info-circle text-success fs-5"></i>
                                        <div className="small">
                                            Wallet balance can be used for <b>promotions</b> and
                                            <b> listing upgrades</b>.
                                        </div>
                                    </div>
                                </div>

                                {/* FOOTER */}
                                <div className="modal-footer px-4 py-3">
                                    <button
                                        className="btn btn-outline-secondary px-4"
                                        onClick={() => setShowAddFund(false)}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        className="btn btn-success px-4"
                                        disabled={
                                            !addAmount ||
                                            Number(addAmount) < 10 ||
                                            payLoading
                                        }
                                        onClick={handleAddFund}
                                    >
                                        {payLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2"></span>
                                                Redirecting...
                                            </>
                                        ) : (
                                            <>
                                                <i className="bi bi-arrow-right-circle me-1"></i>
                                                Proceed to Pay
                                            </>
                                        )}
                                    </button>

                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="modal-backdrop show"></div>
                </>
            )}


            {/* ================= STYLES ================= */}
            <style>{`
                
                    .custom-toast {
    position: fixed;
    top: 20px;
    right: 20px;
    min-width: 320px;
    max-width: 420px;
    background: #fff;
    border-radius: 10px;
    padding: 14px 16px;
    box-shadow: 0 12px 30px rgba(0,0,0,0.12);
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 9999;
    animation: slideIn 0.35s ease-out;
}

.custom-toast.success {
    border-left: 5px solid #22c55e;
}

.custom-toast.danger {
    border-left: 5px solid #ef4444;
}

.custom-toast.info {
    border-left: 5px solid #3b82f6;
}

.toast-icon {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 16px;
    color: #fff;
}

.custom-toast.success .toast-icon {
    background: #22c55e;
}

.custom-toast.danger .toast-icon {
    background: #ef4444;
}

.custom-toast.info .toast-icon {
    background: #3b82f6;
}

.toast-content {
    flex: 1;
}

.toast-title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 2px;
}

.toast-message {
    font-size: 13px;
    color: #555;
}

.toast-close {
    border: none;
    background: transparent;
    font-size: 18px;
    cursor: pointer;
    color: #999;
}

.toast-close:hover {
    color: #000;
}

.toast-progress {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    background: linear-gradient(90deg, #60a5fa, #22c55e);
    animation: progress linear forwards;
    width: 100%;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(30px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes progress {
    from { width: 100%; }
    to { width: 0%; }
}

            `}</style>
        </div>
    );
}
